module.exports = __webpack_public_path__ + "img/macd.ec06c664.png";